import React, { useLayoutEffect } from 'react';
import { useOidc } from "@axa-fr/react-oidc";
import { NavLink } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { PermissionsGate } from '../../../utilities/PermissionsGate';
import { ACCESS_VALUES } from '../../../utilities/constValues';

export const TopNavigation = () => {
    const { login, logout, isAuthenticated } = useOidc();

    const handleLogout = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        sessionStorage.setItem('signedOut', 'true');
        logout();
    }

    useLayoutEffect(() => {
        if (sessionStorage.getItem('needRelogin') === 'true' && !isAuthenticated) {
            //Force user to relog in.
            sessionStorage.removeItem('needRelogin');
            login();
        }
    }, []);


    return (


        <div className="utilityNav justify-content-right">
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={
                <Row className="utilityNavRow"><Col sm='auto'>
                    <NavLink key="Register" onClick={() => login("/Login")} to="/Login">
                        <span>Register</span>
                    </NavLink>
                </Col>
                    <Col sm='auto'>
                        <NavLink className="end" key="LogIn" onClick={() => login("/Login")} to="/Login">
                            <span>Log In</span>
                        </NavLink>
                    </Col>
                </Row>
            }>
                <Row className="utilityNavRow">
                    <Col sm='auto'>
                        <NavLink className={({ isActive, isPending }) => isPending ? "pending" : isActive ? "active" : ""} key="MyAccount" to="/MyAccount">
                            <span>My Account</span>
                        </NavLink>
                    </Col>
                    <Col sm='auto'>
                        <NavLink className="end" key="LogOut" onClick={(e) => handleLogout(e)} to="/" >
                            <span>Log Out</span>
                        </NavLink>
                    </Col>
                </Row>
            </PermissionsGate>
        </div>
    )
}